<template>
  <div class="home-view painel-root-view">
    <div class="titulo painel-root-titulo">
      <div class="grid-3">
        <div style="text-align: center">
          <h2 style="font-weight: 500; color: var(--cor-fonte-fraca)">
            Olá, {{ primeiroNome }}
          </h2>
        </div>
        <div aria-hidden="true"></div>
        <div style="text-align: center">
          <h2 style="font-weight: 500; color: var(--cor-fonte-fraca)">Administração Thalamus</h2>
        </div>
      </div>
    </div>

    <div class="margem painel-root-conteudo">
      <div class="bloco-header-row alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap; margin-bottom: 1rem">
        <button type="button" class="acao-secundaria" @click="voltar">
          ← Voltar às empresas
        </button>
        <span v-if="empresa" style="color: var(--cor-fonte-fraca)">
          ID {{ empresa.id }}
        </span>
      </div>

      <p v-if="erro" class="sem-itens" style="color: var(--cor-erro)">{{ erro }}</p>
      <div v-if="loading" class="sem-itens">Carregando empresa...</div>

      <template v-else-if="empresa">
        <div class="painel-chips" role="tablist" aria-label="Seções da empresa">
          <button
            v-for="aba in abas"
            :key="aba.id"
            type="button"
            class="painel-chip"
            role="tab"
            :class="{ ativo: abaAtiva === aba.id }"
            :aria-selected="abaAtiva === aba.id"
            @click="selecionarAba(aba.id)"
          >
            {{ aba.label }}
          </button>
        </div>

        <div v-show="abaAtiva === 'empresa'" class="bloco margem painel-root-bloco">
          <div class="bloco-header-row alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap">
            <div>
              <h3 class="bloco-titulo" style="margin-bottom: 0.25rem">
                {{ empresa.nome }}
              </h3>
              <p style="color: var(--cor-fonte-fraca); margin: 0">Editar dados cadastrais</p>
            </div>
            <span class="chip" :class="form.ativo ? 'bg-sucesso' : 'bg-erro'">
              {{ form.ativo ? "Ativa" : "Inativa" }}
            </span>
          </div>

          <form class="grid-1" style="margin-top: 1rem; max-width: 520px" @submit.prevent="salvarEmpresa">
            <div>
              <label>Nome</label>
              <input v-model="form.nome" type="text" class="input" required />
            </div>
            <div>
              <label>Slug</label>
              <input v-model="form.slug" type="text" class="input" />
            </div>
            <div>
              <label class="alinha-v" style="gap: 0.5rem">
                <input v-model="form.ativo" type="checkbox" />
                Empresa ativa
              </label>
            </div>

            <hr style="border: none; border-top: 1px solid var(--cor-borda, #ddd); margin: 0.5rem 0" />

            <div>
              <h4 style="margin: 0 0 0.25rem; font-weight: 600">Integração Omie</h4>
              <p style="color: var(--cor-fonte-fraca); margin: 0 0 0.75rem; font-size: 0.9rem">
                Sem Omie, o cadastro de produtos fica só no Thalamus.
              </p>
            </div>
            <div>
              <label class="alinha-v" style="gap: 0.5rem">
                <input v-model="form.omie_habilitado" type="checkbox" />
                Integração Omie habilitada
              </label>
            </div>
            <div v-if="form.omie_habilitado">
              <label>App Key</label>
              <input
                v-model="form.omie_app_key"
                type="text"
                class="input"
                :placeholder="
                  empresa?.omie_app_key_mascarada
                    ? `Atual: ${empresa.omie_app_key_mascarada}`
                    : 'App key da Omie'
                "
                autocomplete="off"
              />
              <p
                v-if="empresa?.omie_configurado && !form.omie_app_key"
                style="color: var(--cor-fonte-fraca); margin: 0.35rem 0 0; font-size: 0.85rem"
              >
                Key já configurada. Preencha apenas para substituir.
              </p>
            </div>
            <div v-if="form.omie_habilitado">
              <label>App Secret</label>
              <input
                v-model="form.omie_app_secret"
                type="password"
                class="input"
                :placeholder="
                  empresa?.omie_configurado
                    ? 'Deixe em branco para manter o secret atual'
                    : 'App secret da Omie'
                "
                autocomplete="new-password"
              />
            </div>
            <p
              v-if="form.omie_habilitado && !empresa?.omie_configurado && !form.omie_app_key"
              style="color: var(--cor-fonte-fraca); margin: 0; font-size: 0.85rem"
            >
              Informe key e secret para cadastrar produtos no Omie.
            </p>

            <div class="submit" style="justify-content: flex-end; margin-top: 0.5rem">
              <button type="submit" :disabled="salvando || !form.nome?.trim()">
                {{ salvando ? "Salvando..." : "Salvar alterações" }}
              </button>
            </div>
          </form>
        </div>

        <div v-show="abaAtiva === 'usuarios'" class="bloco margem painel-root-bloco">
          <div class="bloco-header-row alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap">
            <div>
              <h3 class="bloco-titulo" style="margin-bottom: 0.25rem">Usuários</h3>
              <p style="color: var(--cor-fonte-fraca); margin: 0">
                {{
                  loadingUsuarios
                    ? "Carregando..."
                    : buscaUsuarios.trim()
                      ? `${usuariosFiltrados.length} de ${usuarios.length} usuário(s)`
                      : `${usuarios.length} usuário(s) nesta empresa`
                }}
              </p>
            </div>
            <div class="usuarios-acoes-topo alinha-v">
              <input
                v-model="buscaUsuarios"
                type="search"
                class="input usuarios-busca"
                placeholder="Buscar por nome ou e-mail"
                :disabled="loadingUsuarios"
              />
              <button type="button" class="acao-secundaria" @click="abrirModalCriarUsuario">
                Novo usuário
              </button>
            </div>
          </div>

          <p v-if="erroUsuarios" class="sem-itens" style="color: var(--cor-erro)">
            {{ erroUsuarios }}
          </p>

          <div v-if="!loadingUsuarios && usuariosFiltrados.length" class="painel-tabela-wrap">
            <table class="tabela">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Grupos</th>
                  <th style="text-align: center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="user in usuariosFiltrados" :key="user.id">
                  <td>{{ user.id }}</td>
                  <td>{{ user.name }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ nomesGrupos(user) }}</td>
                  <td class="alinha-centro">
                    <span
                      class="chip"
                      :class="Number(user.user_ativo) === 1 ? 'bg-sucesso' : 'bg-erro'"
                    >
                      {{ Number(user.user_ativo) === 1 ? "Ativo" : "Inativo" }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p
            v-if="!loadingUsuarios && !usuariosFiltrados.length && !erroUsuarios"
            class="sem-itens"
          >
            {{
              usuarios.length
                ? "Nenhum usuário encontrado para essa busca."
                : "Nenhum usuário cadastrado nesta empresa."
            }}
          </p>
        </div>

        <div v-show="abaAtiva === 'grupos'" class="bloco margem painel-root-bloco">
          <div class="bloco-header-row alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap">
            <div>
              <h3 class="bloco-titulo" style="margin-bottom: 0.25rem">Grupos</h3>
              <p style="color: var(--cor-fonte-fraca); margin: 0">
                {{
                  loadingGrupos
                    ? "Carregando..."
                    : `${grupos.length} grupo(s) nesta empresa`
                }}
              </p>
            </div>
            <button type="button" class="acao-secundaria" @click="abrirModalCriarGrupo">
              Criar grupo
            </button>
          </div>

          <p v-if="erroGrupos" class="sem-itens" style="color: var(--cor-erro)">
            {{ erroGrupos }}
          </p>

          <div v-if="!loadingGrupos && grupos.length" class="painel-tabela-wrap">
            <table class="tabela">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th style="text-align: center">Usuários</th>
                  <th style="text-align: center">Funcionalidades</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="grupo in grupos"
                  :key="grupo.id"
                  class="painel-linha-clicavel"
                  @click="abrirModalGrupo(grupo)"
                >
                  <td>{{ grupo.id }}</td>
                  <td>{{ grupo.nome }}</td>
                  <td class="alinha-centro">
                    {{ Array.isArray(grupo.user) ? grupo.user.length : 0 }}
                  </td>
                  <td class="alinha-centro">
                    {{ Array.isArray(grupo.funcionalidade) ? grupo.funcionalidade.length : 0 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p v-if="!loadingGrupos && !grupos.length && !erroGrupos" class="sem-itens">
            Nenhum grupo cadastrado nesta empresa.
          </p>
        </div>
      </template>
    </div>

    <Teleport to="body">
      <div v-if="modalCriarGrupoAberto" class="modal-mask" @click.self="fecharModalCriarGrupo">
        <div
          class="jm margem"
          style="min-width: min(480px, 94vw); max-width: 520px; width: 94vw"
          role="dialog"
          aria-modal="true"
        >
          <h2>Criar grupo</h2>
          <p style="color: var(--cor-fonte-fraca); margin: 0 0 1rem">
            Novo grupo na empresa {{ empresa?.nome }}.
          </p>
          <form class="grid-1" @submit.prevent="salvarNovoGrupo">
            <div>
              <label>Nome</label>
              <input
                v-model="formNovoGrupo.nome"
                type="text"
                class="input"
                required
                minlength="2"
                placeholder="Nome do grupo"
              />
            </div>
          </form>
          <div class="modal-grupo-acoes">
            <button
              type="button"
              class="acao-secundaria"
              @click="fecharModalCriarGrupo"
              :disabled="salvandoNovoGrupo"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="salvarNovoGrupo"
              :disabled="salvandoNovoGrupo || !formNovoGrupo.nome?.trim()"
            >
              {{ salvandoNovoGrupo ? "Salvando..." : "Criar" }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <Teleport to="body">
      <div v-if="modalUsuarioAberto" class="modal-mask" @click.self="fecharModalUsuario">
        <div
          class="jm margem"
          style="min-width: min(520px, 94vw); max-width: 560px; width: 94vw"
          role="dialog"
          aria-modal="true"
        >
          <h2>Novo usuário</h2>
          <p style="color: var(--cor-fonte-fraca); margin: 0 0 1rem">
            Cadastro na empresa {{ empresa?.nome }}.
          </p>
          <form class="grid-1" @submit.prevent="salvarUsuario">
            <div>
              <label>Nome</label>
              <input v-model="formUsuario.name" type="text" class="input" required />
            </div>
            <div>
              <label>E-mail</label>
              <input v-model="formUsuario.email" type="email" class="input" required />
            </div>
            <div>
              <label>Senha</label>
              <input
                v-model="formUsuario.password"
                type="password"
                class="input"
                required
                minlength="8"
                placeholder="Mínimo de 8 caracteres"
              />
            </div>
            <div>
              <label>Grupos</label>
              <div v-if="loadingGruposForm" class="sem-itens" style="margin: 0.5rem 0">
                Carregando grupos...
              </div>
              <div v-else-if="gruposForm.length" class="modal-usuario-grupos">
                <label
                  v-for="grupo in gruposForm"
                  :key="grupo.id"
                  class="modal-grupo-item alinha-v"
                >
                  <input
                    type="checkbox"
                    :value="Number(grupo.id)"
                    v-model="formUsuario.grupo_ids"
                  />
                  <span>{{ grupo.nome }}</span>
                </label>
              </div>
              <p v-else class="sem-itens" style="margin: 0.5rem 0">
                Nenhum grupo nesta empresa.
              </p>
            </div>
          </form>
          <div class="modal-grupo-acoes">
            <button
              type="button"
              class="acao-secundaria"
              @click="fecharModalUsuario"
              :disabled="salvandoUsuario"
            >
              Cancelar
            </button>
            <button
              type="button"
              @click="salvarUsuario"
              :disabled="
                salvandoUsuario ||
                !formUsuario.name?.trim() ||
                !formUsuario.email?.trim() ||
                !formUsuario.password ||
                formUsuario.password.length < 8
              "
            >
              {{ salvandoUsuario ? "Salvando..." : "Cadastrar" }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <Teleport to="body">
      <div v-if="modalGrupoAberto" class="modal-mask" @click.self="fecharModalGrupo">
        <div
          class="jm margem modal-grupo"
          style="min-width: min(720px, 94vw); max-width: 900px; width: 94vw"
          role="dialog"
          aria-modal="true"
        >
          <h2>Grupo #{{ grupoSelecionado?.id }} — {{ grupoSelecionado?.nome }}</h2>
          <p style="color: var(--cor-fonte-fraca); margin: 0 0 1rem">
            Gerencie membros e permissões deste grupo.
          </p>

          <div class="painel-chips" role="tablist" aria-label="Seções do grupo">
            <button
              v-for="aba in abasModalGrupo"
              :key="aba.id"
              type="button"
              class="painel-chip"
              role="tab"
              :class="{ ativo: abaModalGrupo === aba.id }"
              :aria-selected="abaModalGrupo === aba.id"
              @click="abaModalGrupo = aba.id"
            >
              {{ aba.label }}
            </button>
          </div>

          <div v-show="abaModalGrupo === 'usuarios'">
            <div class="alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap; margin-bottom: 0.75rem">
              <span style="color: var(--cor-fonte-fraca)">
                {{ idsUserSelecionados.length }} membro(s)
                <template v-if="buscaUserModal.trim()">
                  · {{ usuariosModalFiltrados.length }} na busca
                </template>
              </span>
              <input
                v-model="buscaUserModal"
                type="search"
                class="input"
                style="min-width: min(260px, 100%); max-width: 300px"
                placeholder="Buscar usuário"
              />
            </div>

            <div class="modal-grupo-lista">
              <label
                v-for="user in usuariosModalFiltrados"
                :key="user.id"
                class="modal-grupo-item alinha-v"
              >
                <input
                  type="checkbox"
                  :checked="idsUserSelecionados.includes(Number(user.id))"
                  @change="toggleUsuario(user.id, $event.target.checked)"
                />
                <span class="modal-grupo-item-texto">
                  <strong>{{ user.name }}</strong>
                  <small>{{ user.email }}</small>
                </span>
              </label>
              <p v-if="!usuariosModalFiltrados.length" class="sem-itens" style="margin: 1rem 0">
                {{
                  usuariosEmpresaModal.length
                    ? "Nenhum usuário encontrado para essa busca."
                    : "Nenhum usuário cadastrado nesta empresa."
                }}
              </p>
            </div>
          </div>

          <div v-show="abaModalGrupo === 'funcionalidades'">
            <div class="alinha-v" style="justify-content: space-between; gap: 1rem; flex-wrap: wrap; margin-bottom: 0.75rem">
              <span style="color: var(--cor-fonte-fraca)">
                {{ idsFuncSelecionados.length }} selecionada(s)
                <template v-if="buscaFuncModal.trim()">
                  · {{ funcionalidadesModalFiltradas.length }} na busca
                </template>
              </span>
              <input
                v-model="buscaFuncModal"
                type="search"
                class="input"
                style="min-width: min(260px, 100%); max-width: 300px"
                placeholder="Buscar funcionalidade"
              />
            </div>

            <div class="modal-grupo-lista">
              <label
                v-for="func in funcionalidadesModalFiltradas"
                :key="func.id"
                class="modal-grupo-item alinha-v"
              >
                <input
                  type="checkbox"
                  :checked="idsFuncSelecionados.includes(Number(func.id))"
                  @change="toggleFuncionalidade(func.id, $event.target.checked)"
                />
                <span>
                  <strong>#{{ func.id }}</strong> — {{ func.nome }}
                </span>
              </label>
              <p v-if="!funcionalidadesModalFiltradas.length" class="sem-itens" style="margin: 1rem 0">
                Nenhuma funcionalidade encontrada.
              </p>
            </div>
          </div>

          <div class="modal-grupo-acoes">
            <button
              type="button"
              class="acao-secundaria"
              @click="fecharModalGrupo"
              :disabled="salvandoGrupo"
            >
              Cancelar
            </button>
            <button type="button" @click="salvarModalGrupo" :disabled="salvandoGrupo">
              {{ salvandoGrupo ? "Salvando..." : "Salvar" }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { sso } from "roboflex-thalamus-sso-lib";
import { createToaster } from "@meforma/vue-toaster";
import empresaRootService from "@/services/empresaRootService";

const toaster = createToaster({ position: "top-right", duration: 4000 });

function formUsuarioVazio() {
  return {
    name: "",
    email: "",
    password: "",
    grupo_ids: [],
  };
}

export default {
  name: "EmpresaRootDetalheView",
  data() {
    return {
      usuarioLogado: sso.getUsuarioLogado() || { nome: "Root" },
      abaAtiva: "empresa",
      abas: [
        { id: "empresa", label: "Empresa" },
        { id: "usuarios", label: "Usuários" },
        { id: "grupos", label: "Grupos" },
      ],
      loading: true,
      loadingUsuarios: false,
      usuariosCarregados: false,
      buscaUsuarios: "",
      loadingGrupos: false,
      gruposCarregados: false,
      grupos: [],
      erroGrupos: "",
      catalogoFuncionalidades: [],
      modalGrupoAberto: false,
      grupoSelecionado: null,
      abaModalGrupo: "usuarios",
      abasModalGrupo: [
        { id: "usuarios", label: "Usuários" },
        { id: "funcionalidades", label: "Funcionalidades" },
      ],
      idsFuncSelecionados: [],
      idsUserSelecionados: [],
      buscaFuncModal: "",
      buscaUserModal: "",
      usuariosEmpresaModal: [],
      salvandoGrupo: false,
      modalUsuarioAberto: false,
      formUsuario: formUsuarioVazio(),
      salvandoUsuario: false,
      loadingGruposForm: false,
      gruposForm: [],
      modalCriarGrupoAberto: false,
      formNovoGrupo: { nome: "" },
      salvandoNovoGrupo: false,
      salvando: false,
      erro: "",
      erroUsuarios: "",
      empresa: null,
      usuarios: [],
      form: {
        nome: "",
        slug: "",
        ativo: true,
        omie_habilitado: false,
        omie_app_key: "",
        omie_app_secret: "",
      },
    };
  },
  computed: {
    primeiroNome() {
      const nome = this.usuarioLogado?.nome || "Root";
      return String(nome).split(" ")[0];
    },
    empresaId() {
      return Number(this.$route.params.id);
    },
    usuariosFiltrados() {
      const termo = this.buscaUsuarios.trim().toLowerCase();
      if (!termo) return this.usuarios;
      return this.usuarios.filter((user) => {
        const nome = String(user.name || "").toLowerCase();
        const email = String(user.email || "").toLowerCase();
        return nome.includes(termo) || email.includes(termo);
      });
    },
    funcionalidadesModalFiltradas() {
      const termo = this.buscaFuncModal.trim().toLowerCase();
      const lista = this.catalogoFuncionalidades;
      if (!termo) return lista;
      return lista.filter((func) => {
        const nome = String(func.nome || "").toLowerCase();
        const id = String(func.id || "");
        return nome.includes(termo) || id.includes(termo);
      });
    },
    usuariosModalFiltrados() {
      const termo = this.buscaUserModal.trim().toLowerCase();
      const lista = this.usuariosEmpresaModal;
      if (!termo) return lista;
      return lista.filter((user) => {
        const nome = String(user.name || "").toLowerCase();
        const email = String(user.email || "").toLowerCase();
        return nome.includes(termo) || email.includes(termo);
      });
    },
  },
  watch: {
    empresaId: {
      immediate: true,
      handler() {
        this.abaAtiva = "empresa";
        this.usuariosCarregados = false;
        this.usuarios = [];
        this.buscaUsuarios = "";
        this.gruposCarregados = false;
        this.grupos = [];
        this.fecharModalCriarGrupo();
        this.fecharModalUsuario();
        this.fecharModalGrupo();
        this.carregar();
      },
    },
  },
  methods: {
    nomesGrupos(user) {
      const grupos = user?.grupo;
      if (!Array.isArray(grupos) || !grupos.length) return "—";
      return grupos.map((g) => g.nome).filter(Boolean).join(", ") || "—";
    },
    voltar() {
      this.$router.push({ name: "painelRoot" });
    },
    async selecionarAba(id) {
      this.abaAtiva = id;
      if (id === "usuarios" && !this.usuariosCarregados) {
        await this.carregarUsuarios();
      }
      if (id === "grupos" && !this.gruposCarregados) {
        await this.carregarGrupos();
      }
    },
    async carregar() {
      if (!this.empresaId) {
        this.erro = "Empresa inválida.";
        this.loading = false;
        return;
      }
      this.loading = true;
      this.erro = "";
      try {
        const empresa = await empresaRootService.buscar(this.empresaId);
        this.empresa = empresa;
        this.form = {
          nome: empresa.nome || "",
          slug: empresa.slug || "",
          ativo: !!empresa.ativo,
          omie_habilitado: !!empresa.omie_habilitado,
          omie_app_key: "",
          omie_app_secret: "",
        };
      } catch (e) {
        this.erro =
          e.response?.status === 404
            ? "Empresa não encontrada."
            : e.response?.status === 403
              ? "Acesso restrito ao usuário root."
              : "Não foi possível carregar a empresa.";
        this.empresa = null;
      } finally {
        this.loading = false;
      }
    },
    async carregarUsuarios() {
      this.loadingUsuarios = true;
      this.erroUsuarios = "";
      try {
        const data = await empresaRootService.listarUsuarios(this.empresaId);
        this.usuarios = Array.isArray(data) ? data : [];
        this.usuariosCarregados = true;
      } catch {
        this.erroUsuarios = "Não foi possível carregar os usuários.";
        this.usuarios = [];
      } finally {
        this.loadingUsuarios = false;
      }
    },
    async carregarGrupos() {
      this.loadingGrupos = true;
      this.erroGrupos = "";
      try {
        const data = await empresaRootService.listarGrupos(this.empresaId);
        this.grupos = Array.isArray(data) ? data : [];
        this.gruposCarregados = true;
      } catch {
        this.erroGrupos = "Não foi possível carregar os grupos.";
        this.grupos = [];
      } finally {
        this.loadingGrupos = false;
      }
    },
    async garantirGruposForm() {
      this.loadingGruposForm = true;
      try {
        if (this.gruposCarregados) {
          this.gruposForm = [...this.grupos];
          return;
        }
        const data = await empresaRootService.listarGrupos(this.empresaId);
        const lista = Array.isArray(data) ? data : [];
        this.grupos = lista;
        this.gruposCarregados = true;
        this.gruposForm = [...lista];
      } catch {
        this.gruposForm = [];
        toaster.show("Não foi possível carregar os grupos.", { type: "error" });
      } finally {
        this.loadingGruposForm = false;
      }
    },
    abrirModalCriarGrupo() {
      this.formNovoGrupo = { nome: "" };
      this.modalCriarGrupoAberto = true;
    },
    fecharModalCriarGrupo() {
      if (this.salvandoNovoGrupo) return;
      this.modalCriarGrupoAberto = false;
      this.formNovoGrupo = { nome: "" };
    },
    async salvarNovoGrupo() {
      const nome = this.formNovoGrupo.nome?.trim();
      if (!nome) return;
      this.salvandoNovoGrupo = true;
      try {
        const criado = await empresaRootService.criarGrupo(this.empresaId, { nome });
        this.grupos = [...this.grupos, criado].sort((a, b) => Number(a.id) - Number(b.id));
        this.gruposCarregados = true;
        this.gruposForm = [...this.grupos];
        toaster.show("Grupo criado.", { type: "success" });
        this.salvandoNovoGrupo = false;
        this.fecharModalCriarGrupo();
        this.abrirModalGrupo(criado);
      } catch (e) {
        const errors = e.response?.data?.errors;
        const msg =
          e.response?.data?.message ||
          (errors && Object.values(errors).flat()[0]) ||
          "Falha ao criar grupo.";
        toaster.show(msg, { type: "error" });
      } finally {
        this.salvandoNovoGrupo = false;
      }
    },
    async abrirModalCriarUsuario() {
      this.formUsuario = formUsuarioVazio();
      this.modalUsuarioAberto = true;
      await this.garantirGruposForm();
    },
    fecharModalUsuario() {
      if (this.salvandoUsuario) return;
      this.modalUsuarioAberto = false;
      this.formUsuario = formUsuarioVazio();
    },
    async salvarUsuario() {
      if (!this.formUsuario.name?.trim() || !this.formUsuario.email?.trim()) return;
      if (!this.formUsuario.password || this.formUsuario.password.length < 8) {
        toaster.show("A senha é obrigatória e deve ter pelo menos 8 caracteres.", {
          type: "error",
        });
        return;
      }
      this.salvandoUsuario = true;
      try {
        const criado = await empresaRootService.criarUsuario(this.empresaId, {
          name: this.formUsuario.name.trim(),
          email: this.formUsuario.email.trim(),
          password: this.formUsuario.password,
          grupo_ids: this.formUsuario.grupo_ids.map(Number),
        });
        this.usuarios = [...this.usuarios, criado].sort((a, b) => Number(a.id) - Number(b.id));
        this.usuariosCarregados = true;
        this.usuariosEmpresaModal = [...this.usuarios].sort((a, b) =>
          String(a.name || "").localeCompare(String(b.name || ""), "pt-BR")
        );
        // Contagens de membros nos grupos podem ter mudado.
        this.gruposCarregados = false;
        toaster.show("Usuário cadastrado.", { type: "success" });
        this.salvandoUsuario = false;
        this.fecharModalUsuario();
      } catch (e) {
        const errors = e.response?.data?.errors;
        const msg =
          e.response?.data?.message ||
          (errors && Object.values(errors).flat()[0]) ||
          "Falha ao cadastrar usuário.";
        toaster.show(msg, { type: "error" });
      } finally {
        this.salvandoUsuario = false;
      }
    },
    async garantirCatalogoFuncionalidades() {
      if (this.catalogoFuncionalidades.length) return;
      const data = await empresaRootService.listarFuncionalidades();
      this.catalogoFuncionalidades = Array.isArray(data)
        ? [...data].sort((a, b) => Number(a.id) - Number(b.id))
        : [];
    },
    async garantirUsuariosEmpresa() {
      if (this.usuariosCarregados && this.usuarios.length) {
        this.usuariosEmpresaModal = [...this.usuarios].sort((a, b) =>
          String(a.name || "").localeCompare(String(b.name || ""), "pt-BR")
        );
        return;
      }
      const data = await empresaRootService.listarUsuarios(this.empresaId);
      const lista = Array.isArray(data) ? data : [];
      this.usuarios = lista;
      this.usuariosCarregados = true;
      this.usuariosEmpresaModal = [...lista].sort((a, b) =>
        String(a.name || "").localeCompare(String(b.name || ""), "pt-BR")
      );
    },
    async abrirModalGrupo(grupo) {
      this.grupoSelecionado = grupo;
      this.abaModalGrupo = "usuarios";
      this.buscaFuncModal = "";
      this.buscaUserModal = "";
      this.idsFuncSelecionados = Array.isArray(grupo.funcionalidade)
        ? grupo.funcionalidade.map((f) => Number(f.id))
        : [];
      this.idsUserSelecionados = Array.isArray(grupo.user)
        ? grupo.user.map((u) => Number(u.id))
        : [];
      this.modalGrupoAberto = true;
      try {
        await Promise.all([
          this.garantirCatalogoFuncionalidades(),
          this.garantirUsuariosEmpresa(),
        ]);
      } catch {
        toaster.show("Não foi possível carregar dados para edição do grupo.", {
          type: "error",
        });
      }
    },
    fecharModalGrupo() {
      if (this.salvandoGrupo) return;
      this.modalGrupoAberto = false;
      this.grupoSelecionado = null;
      this.idsFuncSelecionados = [];
      this.idsUserSelecionados = [];
      this.buscaFuncModal = "";
      this.buscaUserModal = "";
      this.abaModalGrupo = "usuarios";
    },
    toggleFuncionalidade(id, checked) {
      const numId = Number(id);
      if (checked) {
        if (!this.idsFuncSelecionados.includes(numId)) {
          this.idsFuncSelecionados = [...this.idsFuncSelecionados, numId];
        }
        return;
      }
      this.idsFuncSelecionados = this.idsFuncSelecionados.filter((x) => x !== numId);
    },
    toggleUsuario(id, checked) {
      const numId = Number(id);
      if (checked) {
        if (!this.idsUserSelecionados.includes(numId)) {
          this.idsUserSelecionados = [...this.idsUserSelecionados, numId];
        }
        return;
      }
      this.idsUserSelecionados = this.idsUserSelecionados.filter((x) => x !== numId);
    },
    atualizarGrupoNaLista(atualizado) {
      const idx = this.grupos.findIndex((g) => g.id === atualizado.id);
      if (idx >= 0) {
        this.grupos.splice(idx, 1, { ...this.grupos[idx], ...atualizado });
      }
    },
    async salvarModalGrupo() {
      if (!this.grupoSelecionado?.id) return;
      this.salvandoGrupo = true;
      try {
        const [funcsAtualizado, usersAtualizado] = await Promise.all([
          empresaRootService.syncGrupoFuncionalidades(
            this.empresaId,
            this.grupoSelecionado.id,
            this.idsFuncSelecionados
          ),
          empresaRootService.syncGrupoUsuarios(
            this.empresaId,
            this.grupoSelecionado.id,
            this.idsUserSelecionados
          ),
        ]);
        this.atualizarGrupoNaLista({
          ...funcsAtualizado,
          ...usersAtualizado,
          funcionalidade: funcsAtualizado.funcionalidade ?? usersAtualizado.funcionalidade,
          user: usersAtualizado.user ?? funcsAtualizado.user,
        });
        toaster.show("Grupo atualizado.", { type: "success" });
        this.salvandoGrupo = false;
        this.fecharModalGrupo();
      } catch (e) {
        const errors = e.response?.data?.errors;
        const msg =
          e.response?.data?.message ||
          (errors && Object.values(errors).flat()[0]) ||
          "Falha ao salvar o grupo.";
        toaster.show(msg, { type: "error" });
      } finally {
        this.salvandoGrupo = false;
      }
    },
    async salvarEmpresa() {
      if (!this.form.nome?.trim()) return;
      this.salvando = true;
      try {
        const payload = {
          nome: this.form.nome.trim(),
          slug: this.form.slug?.trim() || undefined,
          ativo: !!this.form.ativo,
          omie_habilitado: !!this.form.omie_habilitado,
        };
        if (this.form.omie_habilitado) {
          if (this.form.omie_app_key?.trim()) {
            payload.omie_app_key = this.form.omie_app_key.trim();
          }
          if (this.form.omie_app_secret?.trim()) {
            payload.omie_app_secret = this.form.omie_app_secret.trim();
          }
        } else {
          // Desligar Omie não apaga as chaves (podem reativar depois).
        }
        const atualizado = await empresaRootService.atualizar(this.empresaId, payload);
        this.empresa = atualizado;
        this.form = {
          nome: atualizado.nome || "",
          slug: atualizado.slug || "",
          ativo: !!atualizado.ativo,
          omie_habilitado: !!atualizado.omie_habilitado,
          omie_app_key: "",
          omie_app_secret: "",
        };
        toaster.show("Empresa atualizada.", { type: "success" });
      } catch (e) {
        const msg =
          e.response?.data?.message ||
          e.response?.data?.errors?.slug?.[0] ||
          e.response?.data?.errors?.nome?.[0] ||
          "Falha ao salvar empresa.";
        toaster.show(msg, { type: "error" });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.painel-root-view {
  display: flex;
  flex-direction: column;
  overflow: visible;
  width: 100%;
  max-width: 1600px;
  margin-left: auto;
  margin-right: auto;
}

.painel-root-titulo {
  flex-shrink: 0;
  margin-top: 2rem;
}

.painel-root-conteudo {
  display: flex;
  flex-direction: column;
  overflow: visible;
  padding-bottom: 2rem;
}

.painel-root-bloco {
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.painel-tabela-wrap {
  margin-top: 1rem;
  overflow-x: auto;
  overflow-y: visible;
}

.painel-tabela-wrap .tabela {
  width: max-content;
  min-width: 100%;
}

.usuarios-acoes-topo {
  flex-shrink: 0;
  gap: 0.5rem;
  flex-wrap: nowrap;
}

.usuarios-acoes-topo .usuarios-busca {
  width: 280px;
  max-width: 280px;
  flex: 0 0 280px;
}

.usuarios-acoes-topo .acao-secundaria {
  flex-shrink: 0;
  white-space: nowrap;
}

.painel-chips {
  flex-shrink: 0;
  display: inline-flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
  padding: 3px;
  border-radius: 10px;
  background: var(--cor-cinza2, rgba(0, 0, 0, 0.06));
  border: 1px solid var(--cor-separador);
}

.painel-chip {
  border: none;
  background: transparent;
  color: var(--cor-fonte);
  padding: 0.45rem 0.9rem;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.painel-chip:hover:not(.ativo) {
  color: var(--cor-fonte-forte);
  background: rgba(255, 255, 255, 0.5);
}

.painel-chip.ativo {
  background: var(--cor-primaria);
  color: var(--cor-bg);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.painel-linha-clicavel {
  cursor: pointer;
}

.painel-linha-clicavel:hover td {
  background: rgba(0, 0, 0, 0.03);
}

.modal-grupo {
  display: flex;
  flex-direction: column;
  max-height: min(85vh, 900px);
}

.modal-grupo-acoes {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1rem;
  width: 100%;
}

.modal-grupo-lista {
  flex: 1;
  min-height: 200px;
  max-height: 50vh;
  overflow: auto;
  border: 1px solid var(--cor-separador);
  border-radius: 8px;
  padding: 0.5rem;
}

.modal-grupo-item {
  gap: 0.65rem;
  padding: 0.45rem 0.5rem;
  border-radius: 6px;
  cursor: pointer;
}

.modal-grupo-item:hover {
  background: rgba(0, 0, 0, 0.03);
}

.modal-grupo-item-texto {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
}

.modal-grupo-item-texto small {
  color: var(--cor-fonte-fraca);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.modal-usuario-grupos {
  max-height: 220px;
  overflow: auto;
  border: 1px solid var(--cor-separador);
  border-radius: 8px;
  padding: 0.35rem;
  margin-top: 0.35rem;
}
</style>
